import React from "react"
import ReactMarkdown from "react-markdown"

interface MarkdownProps {
  children: string
}

const Markdown: React.FC<MarkdownProps> = ({ children }) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => (
          <p style={{ margin: "0 0 12px 0", lineHeight: "1.5" }}>{children}</p>
        ),
        a: ({ children, href }) => (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007bff", textDecoration: "underline" }}
          >
            {children}
          </a>
        ),
        strong: ({ children }) => (
          <strong style={{ fontWeight: 600 }}>{children}</strong>
        ),
        code: ({ children, className }) => {
          const isInline = !className
          return isInline ? (
            <code
              style={{
                backgroundColor: "#f8f9fa",
                padding: "2px 6px",
                borderRadius: "4px",
                fontSize: "13px",
                fontFamily: "monospace",
                color: "#e83e8c",
              }}
            >
              {children}
            </code>
          ) : (
            <code
              style={{
                display: "block",
                backgroundColor: "#2d2d2d",
                color: "#f8f8f2",
                padding: "12px",
                borderRadius: "6px",
                fontSize: "13px",
                fontFamily: "monospace",
                overflowX: "auto",
                margin: "12px 0",
              }}
            >
              {children}
            </code>
          )
        },
        pre: ({ children }) => <pre style={{ margin: 0 }}>{children}</pre>,
        ul: ({ children }) => (
          <ul style={{ margin: "0 0 12px 0", paddingLeft: "24px" }}>
            {children}
          </ul>
        ),
        ol: ({ children }) => (
          <ol style={{ margin: "0 0 12px 0", paddingLeft: "24px" }}>
            {children}
          </ol>
        ),
        li: ({ children }) => (
          <li style={{ marginBottom: "4px", lineHeight: "1.5" }}>{children}</li>
        ),
        blockquote: ({ children }) => (
          <blockquote
            style={{
              margin: "0 0 12px 0",
              paddingLeft: "12px",
              borderLeft: "3px solid #ccc",
              color: "#666",
            }}
          >
            {children}
          </blockquote>
        ),
        h1: ({ children }) => (
          <h1
            style={{ margin: "0 0 12px 0", fontSize: "20px", fontWeight: 600 }}
          >
            {children}
          </h1>
        ),
        h2: ({ children }) => (
          <h2
            style={{ margin: "0 0 12px 0", fontSize: "18px", fontWeight: 600 }}
          >
            {children}
          </h2>
        ),
        h3: ({ children }) => (
          <h3
            style={{ margin: "0 0 12px 0", fontSize: "16px", fontWeight: 600 }}
          >
            {children}
          </h3>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  )
}

export default Markdown
